import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Styles from "./edit.module.css";
import { Services } from "Services";
import { AiOutlineClose } from "react-icons/ai";
import Select from "react-select";
import { SuccessSwal, warningSwal } from "Util/Toast";

Modal.setAppElement("#root");

const TutorEdit = ({ modal, setModal, data, getscheduledClasses }) => {
    const [tutors, setTutors] = useState([]);
    const [selectedTutor, setSelectedTutor] = useState(null);
    const [tutorSearchString, setTutorSearchString] = useState("");
    const [tutorSearchLoad, setTutorSearchLoad] = useState(false);
    const [loading, setLoading] = useState(false);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    useEffect(() => {
        if (data?.TutorID) {
            setSelectedTutor({
                value: data.TutorID,
                label: data.TutorName,
            });
        }
    }, [data]);

    useEffect(() => {
        const debouncedSearch = setTimeout(async () => {
            if (
                typeof tutorSearchString == "string" &&
                tutorSearchString?.length > 0
            ) {
                setTutorSearchLoad(true);

                try {
                    const response = await Services.searchActiveTutor(
                        "POST",
                        JSON.stringify({ SearchString: tutorSearchString }),
                        token
                    );
                    const formattedOptions = response.Tutors?.filter(
                        (item) => item.TutorStatus == 1
                    )?.map((tutor) => ({
                        label: `${tutor.FirstName} ${tutor.LastName}`,
                        value: tutor.TutorID,
                    }));
                    setTutors(formattedOptions);
                } catch (error) {
                    console.error("Error fetching options:", error);
                } finally {
                    setTutorSearchLoad(false);
                }
            }
        }, 300);

        return () => clearTimeout(debouncedSearch);
    }, [tutorSearchString]);

    const handleTutorChange = (searchString) => {
        setTutorSearchString(searchString);
    };

    const onTutorSelect = (option) => {
        setSelectedTutor(option);
    };

    const closeModal = () => {
        setModal(false);
    };

    const onSubmit = async () => {
        if (!selectedTutor) {
            warningSwal("Warning", "Please select a tutor");
            return;
        }

        setLoading(true);
        try {
            // We use UPdateDemoClass which expects the whole body or at least the fields to be updated.
            // Since we only want to update the tutor, we construct a body with the tutor update.
            // In addDemo/index.jsx, it seems it sends everything.
            // To be safe, we send the existing data plus the new TutorID.
            const body = {
                ...data,
                TutorID: selectedTutor.value,
            };

            const response = await Services.UPdateDemoClass(
                "PUT",
                JSON.stringify(body),
                token,
                data.DemoClassID
            );

            if (response?.Status == 1) {
                SuccessSwal("Success", response.Message);
                getscheduledClasses();
                closeModal();
            } else {
                warningSwal("Warning", response.Message);
            }
        } catch (error) {
            console.error("Error updating tutor:", error);
            warningSwal("Error", "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={modal}
            contentLabel="Modal"
            className={Styles["modal"]}
            onRequestClose={closeModal}
            overlayClassName={Styles["overlay"]}>
            <div className={Styles["form-wrapper"]}>
                <button className={Styles["close-btn"]} onClick={closeModal}>
                    <AiOutlineClose />
                </button>
                <h2>Edit Tutor</h2>
                <div className={Styles["form-control"]}>
                    <label htmlFor="Tutor">Select Tutor</label>
                    <Select
                        options={tutors}
                        onInputChange={handleTutorChange}
                        value={selectedTutor}
                        onChange={onTutorSelect}
                        isClearable
                        placeholder="Search Tutor"
                        isLoading={tutorSearchLoad}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        maxMenuHeight={200}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                    />
                </div>
                <div className={Styles["buttons"]}>
                    <button
                        className={Styles["submit"]}
                        onClick={onSubmit}
                        disabled={loading}>
                        {loading ? "Updating..." : "Update Tutor"}
                    </button>
                    <button className={Styles["close"]} onClick={closeModal}>
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default TutorEdit;
